// extracted by mini-css-extract-plugin
export var dark = "index-module--dark--Y3fBL";
export var fullWidthCalloutContainer = "index-module--fullWidthCalloutContainer--luSVl";
export var linkText = "index-module--linkText--ZC48S";
export var titleText = "index-module--titleText--m1WJ-";